import type { UseOrderTicketControllerReturn } from "../OrderTicket.controller";
import { useCryptoOrderTicketController } from "./CryptoOrderTicket.controller";
import { CryptoOrderTicketPresentation } from "./CryptoOrderTicket.pres";

export interface CryptoOrderTicketConnectorProps
  extends Omit<
    UseOrderTicketControllerReturn,
    | "contract"
    | "isContractSymbol"
    | "isCryptoSymbol"
    | "clock"
    | "onSymbolChange"
    | "isSymbolInputAutoFocus"
    | "feedLabel"
  > {
  AssetSearch: JSX.Element;
  fill?: boolean;
  initialQuantity?: number;
}

export const CryptoOrderTicketConnector = ({
  product,
  account,
  margin,
  positions,
  symbol,
  quote,
  refetchQuote,
  asset,
  AssetSearch,
  fill,
  initialQuantity,
}: CryptoOrderTicketConnectorProps) => {
  const props = useCryptoOrderTicketController({
    account,
    product,
    asset,
    margin,
    positions,
    quote,
    symbol,
    initialQuantity,
  });

  return (
    <CryptoOrderTicketPresentation
      asset={asset}
      quote={quote}
      onRefreshQuoteClicked={refetchQuote}
      AssetSearch={AssetSearch}
      fill={fill}
      {...props}
    />
  );
};
